import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
export const sha256 = function () {
  var _ref = _asyncToGenerator(function* (message) {
    const msgUint8 = new TextEncoder().encode(message);
    const hashBuffer = yield crypto.subtle.digest('SHA-256', msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  });

  return function sha256(_x) {
    return _ref.apply(this, arguments);
  };
}();